import * as React from 'react';
import {mediaMobileOnly} from '../theme/media';
import {classes, style} from 'typestyle';
import {colorWhite} from '../theme/color';
import {px} from 'csx';

export interface PageHomePricingSubHeaderProps {
  className?: string;
  i18n?: {
    title: string;
  }
}

const DEFAULT_I18N = {
  title: 'What you get'
};


const styles = {
  container: style(
    {
      $nest: {
        '& h3': {
          margin: '0 0 30px 0',
          color: colorWhite.toString(),
          fontSize: px(36)
        }
      }
    },
    mediaMobileOnly({
      display: 'none'
    })
  )
};

export const PageHomePricingSubHeader: React.SFC<PageHomePricingSubHeaderProps> = ({ i18n = DEFAULT_I18N, className }) => (
  <div className={classes(styles.container, className)}>
    <h3>{i18n.title}</h3>
  </div>
);